import { Flex, Spin } from 'antd';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AUTH_DATA_STORAGE_KEY } from '../../common/constants';
import { AuthResponse } from '../../store/api/types.api';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { setAccessToken, setAuthLoading } from '../../store/reducers/common.slice';
// import { userApi } from '../../store/api/user.api';
// import ChangePasswordModal from '../../components/ChangePasswordModal';

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const { authLoading } = useTypedSelector((state) => state.common);

  // const { data: userInfo } = userApi.useGetUserInfoQuery();

  useEffect(() => {
    if (authLoading) {
      const accountData = localStorage.getItem(AUTH_DATA_STORAGE_KEY);
      if (accountData) {
        const parsedAuthData: AuthResponse = JSON.parse(accountData);
        dispatch(setAccessToken(parsedAuthData.accessToken));
      }
      dispatch(setAuthLoading(false));
    }
  }, [dispatch, authLoading]);

  if (authLoading) {
    return (
      <Flex justify="center" align="center" style={{ height: '100vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  // if (!userInfo) {
  //   return (
  //     <Flex justify="center" align="center" style={{ height: '100vh' }}>
  //       <h3>Не удалось получить данные пользователя</h3>
  //     </Flex>
  //   );
  // }

  return <>
    {children}
  </>;
};
